import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Divider,
  Stack,
  Typography
} from "@mui/material";
import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const InternshiCardMobile = ({
  interventionType,
  purpose,
  providerExpectation,
  learnerExpectation,
  index
}) => {
  return (
    <Accordion
      sx={{
        mb: 2,
        borderRadius: 2,
        boxShadow: 3,
        "&:before": {
          display: "none"
        },
        "&.Mui-expanded": {
          boxShadow: 6
        }
      }}
      disableGutters
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "#FFFFFF" }} />}
        aria-controls={`panel${index}-content`}
        id={`panel${index}-header`}
        sx={{
          backgroundColor: "primary.main",
          borderRadius: "8px 8px 0 0",
          "&.Mui-expanded": {
            borderRadius: "8px 8px 0 0"
          }
        }}
      >
        <Box display="flex" alignItems="center" gap={2} width="100%">
          <Chip
            label={`#${index + 1}`}
            size="small"
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              color: "white",
              fontWeight: "bold"
            }}
          />
          <Typography
            variant="h6"
            sx={{
              color: "white",
              fontWeight: "bold",
              fontSize: "1rem"
            }}
          >
            {interventionType}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 3 }}>
        <Stack spacing={3}>
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "primary.main",
                mb: 1,
                fontSize: "1rem"
              }}
            >
              📋 Purpose
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
              {purpose}
            </Typography>
          </Box>

          <Divider />

          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "primary.main",
                mb: 1,
                fontSize: "1rem"
              }}
            >
              👨‍🎓 Learner Expectations
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
              {learnerExpectation}
            </Typography>
          </Box>

          <Divider />

          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "primary.main",
                mb: 1,
                fontSize: "1rem"
              }}
            >
              🏢 Provider Expectations
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
              {providerExpectation}
            </Typography>
          </Box>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default InternshiCardMobile;
